import { FileInput, FileText, Plus } from 'lucide-react';
import { supabase } from '../../lib/supabase';
import type { ModelloDocumenti } from '../../lib/stores/documentRequestTemplateStore';
import type { LeadFormDocumentRequirement } from '../../lib/types/leadForm';

/**
 * Da dove partire quando si chiedono documenti: un modello, l'elenco di un
 * modulo che ha gia' il campo "Documenti richiesti", oppure un elenco nuovo.
 */

/** I moduli con il campo "Documenti richiesti", nella stessa forma dei modelli. */
export async function caricaModuliConDocumenti(): Promise<ModelloDocumenti[]> {
  const { data } = await supabase.from('lead_forms').select('id, name, fields').order('name').limit(200);
  const risultato: ModelloDocumenti[] = [];
  for (const modulo of (data ?? []) as Array<{ id: string; name: string; fields: any[] | null }>) {
    const campo = (modulo.fields ?? []).find((c) => c?.type === 'documents');
    const requirements = (campo?.documentsConfig?.requirements ?? []) as LeadFormDocumentRequirement[];
    if (requirements.some((r) => r.label?.trim())) {
      risultato.push({
        id: modulo.id,
        name: modulo.name,
        requirements: requirements.filter((r) => r.label?.trim()),
        giorni_validita: campo?.documentsConfig?.giorniValidita ?? 30,
      });
    }
  }
  return risultato;
}

interface Props {
  modelli: ModelloDocumenti[];
  moduli: ModelloDocumenti[];
  onScegli: (elenco: ModelloDocumenti | null, tipo?: 'modello' | 'modulo') => void;
}

const riga =
  'flex w-full items-start gap-3 rounded-lg border border-[rgba(55,53,47,0.09)] px-3 py-2.5 text-left transition-colors hover:bg-[rgba(55,53,47,0.03)] dark:border-gray-700 dark:hover:bg-white/[0.03]';

function Voce({ elenco, icona, onClick }: { elenco: ModelloDocumenti; icona: 'modello' | 'modulo'; onClick: () => void }) {
  const Icona = icona === 'modello' ? FileText : FileInput;
  return (
    <button type="button" onClick={onClick} className={riga}>
      <Icona className="mt-0.5 h-4 w-4 flex-shrink-0 text-[#787774]" strokeWidth={1.5} />
      <span className="min-w-0">
        <span className="block text-sm font-medium text-[#37352F] dark:text-white">{elenco.name}</span>
        <span className="block truncate text-xs text-[#787774]">
          {elenco.requirements.length} documenti: {elenco.requirements.map((v) => v.label).join(', ')}
        </span>
      </span>
    </button>
  );
}

const titoletto = 'text-[11px] font-medium uppercase tracking-wide text-[#9B9A97]';

export default function SceltaElencoDocumenti({ modelli, moduli, onScegli }: Props) {
  return (
    <div className="space-y-2">
      {modelli.length > 0 && moduli.length > 0 && <p className={titoletto}>Modelli</p>}
      {modelli.map((m) => (
        <Voce key={m.id} elenco={m} icona="modello" onClick={() => onScegli(m, 'modello')} />
      ))}

      {moduli.length > 0 && (
        <>
          <p className={`${titoletto} ${modelli.length > 0 ? 'pt-2' : ''}`}>Dai moduli</p>
          {moduli.map((m) => (
            <Voce key={m.id} elenco={m} icona="modulo" onClick={() => onScegli(m, 'modulo')} />
          ))}
        </>
      )}

      <button
        type="button"
        onClick={() => onScegli(null)}
        className="flex w-full items-center gap-3 rounded-lg border border-dashed border-[rgba(55,53,47,0.16)] px-3 py-2.5 text-left text-sm text-[#787774] transition-colors hover:bg-[rgba(55,53,47,0.03)] hover:text-[#37352F]"
      >
        <Plus className="h-4 w-4" />
        Elenco nuovo
      </button>
    </div>
  );
}
